import { Component, OnInit, OnDestroy } from '@angular/core';
import { ProductBasic } from 'src/app/models/catalogs-model/product.model';
import { Subscription } from 'rxjs';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-catalogs-product-dashboard',
  templateUrl: './catalogs-product-dashboard.component.html',
  styleUrls: ['./catalogs-product-dashboard.component.scss']
})
export class CatalogsProductDashboardComponent implements OnInit, OnDestroy {

  product: ProductBasic;
  preparations;
  productPreparations;
  magnitudes = ['ud', 'qty', 'gr', 'kg', 'ml', 'mm', 'inch', 'oz'];
  getProductInfoSubscription: Subscription;
  getProductInfoSubscriptionRefresh: Subscription;
  getPreparationsSubscription: Subscription;
  getProductPreparationsSubscription: Subscription;

  constructor(private productsService: ProductsService,
              private snackbarService: SnackBarService,
              private preparationsService: PreparationsService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getProductInfo();
    this.getPreparations();
    this.getProductInfoSubscriptionRefresh = this.productsService.refreshProductListen().subscribe(
      (res) => {
        this.getProductInfo();
      }
    );
  }

  private getProductInfo() {
    const internalId = this.activatedRoute.snapshot.params['productid'];
    this.getProductInfoSubscription = this.productsService.getProductInfo(internalId).subscribe(
      (res) => {
        this.product = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getPreparations() {
    this.getPreparationsSubscription = this.preparationsService.getPreparationsList().pipe(
      tap(o => this.preparations = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-boxes', 'catalogs-page.product detail', '/catalog/products', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.products', '/catalog/products'), new BRoute('catalogs-page.product detail')]));
  }

  ngOnDestroy() {
    if (this.getProductInfoSubscription) { this.getProductInfoSubscription.unsubscribe(); }
    if (this.getProductInfoSubscriptionRefresh) { this.getProductInfoSubscriptionRefresh.unsubscribe(); }
    if (this.getPreparationsSubscription) { this.getPreparationsSubscription.unsubscribe(); }
    if (this.getProductPreparationsSubscription) { this.getProductPreparationsSubscription.unsubscribe(); }
  }
}
